import styled from "styled-components";

export const HeaderContainer = styled.header`
  width: 100%;
  height: 110px;
  background-color: white;
  padding: 0 10%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  a {
    height: 100%;
  }

  .logo {
    height: 100%;
    width: auto;
    object-fit: contain;
  }

  .logo-small {
    display: none;
  }

  @media (max-width: 1400px) {
    padding: 0 2%;
  }

  @media (max-width: 750px) {
    .logo-small {
      display: flex;
    }
    .logo-big {
      display: none;
    }
  }
`;

export const LogOutButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  max-width: 150px;
  border: none;
  padding: 20px 45px;
  font-size: 1rem;
  font-weight: 500;
  color: #104467;
  transition: background 0.2s ease, transform 0.05s ease;

  &:hover {
    cursor: pointer;
    background: #f5f5f5;
  }

  &:active {
    background: #e0e0e0;
    transform: scale(0.98);
  }
`;
